import React from 'react'
import ReactPlayer from "react-player";
function Youtubevideo() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                    <div className="col-md-4 mt-3">
                            <div className=" mb-4">
                                <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=A2tJsrwAD9Q"/>
                                <div className="card-body">
                                    <div className='colornew'>
                                    <h5 className="card-text mt-2 mb-2">The Love Birds #icecreamparlour #delicious #waffle #chocolate</h5>
                                    </div>


                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className=" mb-4">
                                <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=T7K4GfknCQw"/>
                                <div className="card-body">
                                    <div className='colornew'>
                                    <h5 className="card-text mt-2 mb-2">The Love Birds Icecream parlour Singer Shiraz Uppal, Jaswinder Singh RaanjhanaaLyricist Irshad Kamil
                                    </h5>
                                    </div>


                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className=" mb-4">
                                <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=TqKTPYLpMTI"/>
                                <div className="card-body">
                                    <div className='colornew'>
                                    <h5 className="card-text mt-2 mb-2"> The Love Birds icecream parlour at krishnagar #icecream #delicious</h5>
                                    </div>
                                    

                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>
                        </div>
                      
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Youtubevideo